import moment from "moment";

export const noop = () => {};
export const formatDate = date => moment(date).format("DD/MM/YYYY");
